import createStandardI18nProvider from 'I18n/init/providers/createStandardI18nProvider';
import { initAppTranslations } from 'I18n/init/setup/AppInit';
import lang from 'i2l?query=sporks!../../../lang/en.lyaml';
import { setLangKey } from '../../utils/getLangKey';
export const setupI18n = async (locale, isNativeI18nEnabled) => {
  if (!isNativeI18nEnabled) {
    return;
  }
  const I18nProvider = createStandardI18nProvider();
  I18nProvider.setLocale({
    locale,
    langEnabled: true
  });
  const langAvailable = initAppTranslations([I18nProvider.register(lang)]);
  const langKey = locale.split('-')[0];
  setLangKey(langKey);
  await langAvailable;
};